// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

const initialUser = () => {
  const item = window.localStorage.getItem('userData')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {}
}

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser()
  },
  reducers: {
    handleLogin: (state, action) => {
      state.userData = {...action.payload}
      delete state.userData.config;
      state[action.payload.config.storageTokenKeyName] = action.payload[action.payload.config.storageTokenKeyName]
      state[action.payload.config.storageRefreshTokenKeyName] = action.payload[action.payload.config.storageRefreshTokenKeyName]
      localStorage.setItem('userData', JSON.stringify(action.payload))
      localStorage.setItem(action.payload.config.storageTokenKeyName, action.payload.accessToken)
      localStorage.setItem(action.payload.config.storageRefreshTokenKeyName, action.payload.refreshToken)
    },
    handleLogout: (state, action) => {
      state.userData = {}
      state[action.payload.config.storageTokenKeyName] = null
      state[action.payload.config.storageRefreshTokenKeyName] = null
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem(action.payload.config.storageTokenKeyName)
      localStorage.removeItem(action.payload.config.storageRefreshTokenKeyName)
    },
    handleRefreshToken: (state, action) => {
      state[action.payload.config.storageTokenKeyName] = action.payload[action.payload.config.storageTokenKeyName]
      state[action.payload.config.storageRefreshTokenKeyName] = action.payload[action.payload.config.storageRefreshTokenKeyName]
      localStorage.setItem(action.payload.config.storageTokenKeyName, action.payload.accessToken)
      localStorage.setItem(action.payload.config.storageRefreshTokenKeyName, action.payload.refreshToken)
    }
  }
})

export const { handleLogin, handleLogout, handleRefreshToken } = authSlice.actions

export default authSlice.reducer
